import { SubscriptionIntervalTypes } from '../../utils/constants';
import { SubscriptionTypes } from './constants';

// The one place a viewer is bucketed into an analytics subscription tier. Every Segment event that
// reports a subscription dimension derives it from here, so the same member is never bucketed two
// ways across UTR funnels — the drift this consolidates was a real defect, not a hypothetical.
//
// `isPowered` is the only gate on `free`: a powered member is never reported free, whatever their
// term resolves to. Some powered members have no resolvable term — MemberIsPowered ORs in
// MemberIsPoweredByOrganizerStatus, but the API's GetSubscriptionTierType has no matching branch,
// so owners and admins of Pro-College, Enterprise and Premium clubs arrive with isPowered true and
// a null term. They default to monthly, which keeps them on the powered side of a conversion
// funnel they can never convert in.
//
// A signed-out viewer reports `free` rather than a bucket of its own; their events carry no Segment
// userId, so "free with no memberId" already identifies them in the warehouse.
export const deriveUserSubscriptionType = (user) => {
    if (!user?.isPowered) {
        return SubscriptionTypes.FREE;
    }

    if (user.subscriptionTierType === SubscriptionIntervalTypes.YEAR) {
        return SubscriptionTypes.ANNUAL;
    }

    return SubscriptionTypes.MONTHLY;
};
